import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { orgQueryKeys } from "@/global-settings/data/orgQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import { APIKeyWithKey, CreateAPIKeyBody } from "@reflag/shared/apiKeyAPI";

export function useAPIKeyCreateMutation() {
  const { org } = useEnvironment();
  const queryClient = useQueryClient();

  return useMutation<
    { apiKey: APIKeyWithKey },
    AxiosError<ErrorResponse>,
    CreateAPIKeyBody
  >({
    mutationFn: (data: CreateAPIKeyBody) =>
      api
        .post<"/orgs/:orgId/api-keys">(`/orgs/${org.id}/api-keys`, data)
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: orgQueryKeys.apiKeys(org.id),
      });
    },
  });
}
